import SecureStorage from "./secureStorage";

// Define the logout function
async function logout(isNewTab = false) {
  try {
    // Get auth data before clearing storage
    const auth = await SecureStorage.getItem("auth");

    // If it's a new tab check and user is authorized, redirect to dashboard
    if (isNewTab && auth && auth.authorized) {
      if (auth.role === "admin") {
        window.location.href = "/admin/admin-dashboard-screen/unassigned-tickets";
      } else {
        window.location.href = "/dashboard";
      }
      return;
    }

    // Otherwise proceed with normal logout
    // Clear cookies
    document.cookie.split(";").forEach((c) => {
      document.cookie = c
        .replace(/^ +/, "")
        .replace(/=.*/, "=;expires=" + new Date().toUTCString() + ";path=/");
    });

    // Clear storage
    await SecureStorage.clear();

    // Redirect based on previous role
    if (auth && auth.role === "admin") {
      window.location.href = "/login-admin";
    } else {
      window.location.href = "/";
    }

  } catch (error) {
    console.error("Error during logout:", error);
    window.location.href = "/";
  }
}

// Export the logout function
export default logout;
